import { render, staticRenderFns } from "./MainBlog.vue?vue&type=template&id=c1a2be68&"
import script from "./MainBlog.vue?vue&type=script&lang=js&"
export * from "./MainBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports